module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kallern-e2601f127987d94c2bd72e2cf5d1d84d.svg";